/** An itinerary's days counted the way the app counts them: each row spans `day_span` days
 *  (the funnel clamps it to at least 1), so eight rows can make a twelve-day trip. Shared by
 *  the fact band's Trip cell and the Day ribbon. */
import type { ItineraryDay } from '@/api/itineraries';

/** A row's span as the funnel stores it: a whole number of days, at least 1. */
export function daySpan(span: number | null | undefined): number {
  return typeof span === 'number' && Number.isFinite(span) && span >= 1 ? Math.floor(span) : 1;
}

/** The trip's length in days: the sum of its rows' spans (0 with no rows). */
export function tripDayCount(days: readonly Pick<ItineraryDay, 'day_span'>[]): number {
  return days.reduce((sum, d) => sum + daySpan(d.day_span), 0);
}
